// we have made a copy of the extension keys to avoid importing the constants from the extensions packages
// this is a temporary solution to avoid the bundle size increase
// todo: we will have to create a new package for the constants and import it here

export const EXTENSIONS_CRITICAL_FOR_PAGE_LOAD: Set<string> = new Set<string>([
	'links-menu',
	'cards',
	'spotlight',
	'carousel',
	'hub-section',
	'jsm-help',
]);
